import React from 'react'
import {CardBox} from '../BaseCard/styles'
import DivisionProgress from '../../DivisionProgress'
import {useSelector} from 'react-redux'
import {selectOrganization} from '../../../../redux/courses'
import {Divisions} from '../../../../constants/divisions'
import {Attempt} from '../../../../redux/reportExamStatus'

type Props = {
  division: Divisions
  examReports?: Attempt[]
}

const View = ({division, examReports}: Props) => {
  const organization = useSelector(selectOrganization)

  const course = organization?.courses
    .filter(course => {
      return ['PcM', 'PjM', 'PA', 'PPD', 'PDD', 'CE'].includes(
        course.abbreviation,
      )
    })
    .find(c => c.abbreviation === division)

  const uniqueReports: Attempt[] = Object.values(
    (examReports ?? [])
      .filter(report => report.courseId)
      .reduce<Record<string, Attempt>>((acc, report) => {
        if (
          !acc[report.courseId] ||
          new Date(report.updatedAt) > new Date(acc[report.courseId].updatedAt)
        ) {
          acc[report.courseId] = report
        }
        return acc
      }, {}),
  )

  const reportStatus = uniqueReports.find(ur => ur.courseId === course?.id)

  return (
    <CardBox>
      <DivisionProgress
        courseId={course?.id}
        division={division}
        studyGuides={course?.studyGuides}
        source={'card'}
        reportStatus={reportStatus}
      />
    </CardBox>
  )
}

export default View
